import { assignCallDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const assignCallCallable = getCallable(assignCallDefinition);
